import { render, staticRenderFns } from "./GrossSalesKPM.vue?vue&type=template&id=097870ea"
import script from "./GrossSalesKPM.vue?vue&type=script&lang=js"
export * from "./GrossSalesKPM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports